export default __webpack_public_path__ + "static/media/backgroundVideo.5bd76fb2.jpg";